import { render, staticRenderFns } from "./ModalPendencia.vue?vue&type=template&id=d7ee356e"
import script from "./ModalPendencia.vue?vue&type=script&lang=js"
export * from "./ModalPendencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports